import React from "react";

import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";


import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ProfileAndBanner from "../../Donations/DonationDrawer/ProfileAndBanner";

import {  useTheme } from "@mui/material";

import ActionCard from "../Actions/ActionCard";
import { ComponentType } from "../../../common/enum";
import { actionViewTabs } from "../../../data";

const CollectionDrawer = ({
  drawerState,
  toggleDrawer,
  collectionDetail,
  t,
}) => {
  const theme = useTheme();
 
  const handleClick = React.useCallback(() => {
    toggleDrawer(false);
  }, []);
  
  return (
    <>
      <Drawer
        anchor={"right"}
        open={drawerState}
        onClose={() => toggleDrawer(false)}
        PaperProps={{
          sx: {
            width: "50%",
            [theme.breakpoints.down("md")]: {
              width: "100%",
            },
          },
        }}
      >
        <Button
          sx={{
            position: "fixed",
            right: "51%",
            top: 10,
            zIndex: 1,
            minWidth: 0,
            borderRadius: "4px",
            padding: "4px",
            backgroundColor: "#ffc3c3",
            "&:hover": {
              backgroundColor: "#ffc3c3",
            },
            [theme.breakpoints.down("md")]: {
              right: "1%",
            },
          }}
          onClick={handleClick}
        >
          <CloseOutlinedIcon color="error" />
        </Button>
        <ProfileAndBanner entityLeastDetails={collectionDetail?.entity} />
        <Box sx={{ mt: 6 }}>
          <ActionCard
            component={ComponentType.AGENDA}
            collection={collectionDetail}
            actionViewTabs={actionViewTabs}
            t={t}
          />
        </Box>
      </Drawer>
    </>
  );
};

export default CollectionDrawer;
